import axios from 'axios';

export const INVITATION_URL = 'https://invitation.serenityrsvp.id';
export const PRINT_URL = `${INVITATION_URL}/print/response.php`;

const api = axios.create({
  baseURL: `${INVITATION_URL}/wp-json/`,
});

// Automatically set Authorization header if token exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const loginResponse = async (username, password) => {
  const response = await api.post('jwt-auth/v1/token', { username, password });
  return response.data;
};

export const getUser = async () => {
  const response = await api.get('tribox/v1/me');
  return response.data;
};

export const searchClients = async (query) => {
  const response = await api.get(`/fairytale/v1/posts-with-customer?search=${encodeURIComponent(query)}&acf_format=standard`);
  return response.data;
};


export const getCheckins = async (customer, params = {}) => {
  const response = await api.get('/fairytale/v1/checkins', {
    params: { customer, ...params },
  });
  return response.data;
};

export const getDashboardStats = async (customer) => {
  const response = await api.get('/fairytale/v1/dashboard-stats', {
    params: { customer },
  });
  return response.data;
};

export const setSouvenir = async (customer, { value, total }) => {
  const params = { customer };
  if (value !== undefined) params.value = value;
  if (total !== undefined) params.total = total;

  const response = await api.post('/fairytale/v1/souvenir', null, { params });
  return response.data;
};

export const getEventNotes = async (customer) => {
  const response = await api.get('/fairytale/v1/notes', { params: { customer } });
  return response.data;
};

export const saveEventNotes = async (customer, notes) => {
  const response = await api.post('/fairytale/v1/notes', { notes }, { params: { customer } });
  return response.data;
};

export const saveTamuNote = async (postId, catatan) => {
  const response = await api.post('/fairytale/v1/tamu-note', { post_id: postId, catatan });
  return response.data;
};

export const updateTamuMeta = async (postId, meta) => {
  const response = await api.post('/fairytale/v1/update-meta', {
    post_id: postId,
    meta,
  });
  return response.data;
};

export { api };
